<ng-container [ngSwitch]="dataType">
    <span *ngSwitchCase="DataTypes.Date">
        {{value | date: 'dd/MM/yyyy'}}</span>

    <span *ngSwitchCase="DataTypes.List">
        {{(value | findInListById: availableValues)?.Valeur }}
    </span>

    <span *ngSwitchCase="DataTypes.Boolean">
          {{value | yesNo}}
    </span>

    <span *ngSwitchDefault>{{value}}</span>
</ng-container>
